import React from "react";
import styles from "./Legend.module.scss";

interface Props {
  labels: {
    name: string;
    color: string;
  }[];
}

function Legend({ labels }: Props) {
  return (
    <div className={styles.container}>
      {labels.map(({ name, color }) => (
        <div className={styles.label} key={name}>
          <div className={styles.color} style={{ backgroundColor: color }} />
          <span className={styles.name}>{name}</span>
        </div>
      ))}
    </div>
  );
}

export default Legend;
